import { useKeyPress } from '@pairy/react-hooks';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { v2ViewModeAtom } from '../../store/v2/viewer.atom';

interface Props {
  goToPrevPage: () => void;
  goToNextPage: () => void;
}

/**
 * V2 페이지 모드 키보드 내비게이션(V1 KeyPressLayer와 동일한 키 바인딩).
 * 스크롤 모드에서는 네이티브 스크롤에 맡긴다.
 */
const useV2KeyPress = ({ goToPrevPage, goToNextPage }: Props) => {
  const viewMode = useAtomValue(v2ViewModeAtom);

  const isPressPrevPage = useKeyPress('ArrowLeft, PageUp, ArrowUp');
  const isPressNextPage = useKeyPress('ArrowRight, ArrowDown, PageDown');

  useEffect(() => {
    if (viewMode !== 'paged') {
      return;
    }

    if (isPressPrevPage) {
      goToPrevPage();
    }
    if (isPressNextPage) {
      goToNextPage();
    }
  }, [isPressPrevPage, isPressNextPage]);
};

export default useV2KeyPress;
